// Overlay coordinates use PDF page units with a top-left origin. Keep that
// coordinate system stable when /Rotate or CropBox changes, and transform
// only the editing surface to match PDF.js's displayed viewport.
export function pageGeometry(page, bounds) {
  const viewport = page.getViewport({ scale: 1 });
  const baseWidth = bounds?.width || page.view?.[2] || viewport.width;
  const baseHeight = bounds?.height || page.view?.[3] || viewport.height;
  const [a, b, c, d, e, f] = viewport.transform || [1, 0, 0, -1, 0, baseHeight];
  return { width: viewport.width, height: viewport.height, baseWidth, baseHeight,
    rotation: ((page.rotate || 0) % 360 + 360) % 360,
    matrix: [a, b, -c, -d, c * baseHeight + e, d * baseHeight + f],
    crop: page.view };
}

export function pageOverlayStyle(geometry, zoom) {
  if (!geometry?.matrix) return {};
  const [a, b, c, d, e, f] = geometry.matrix;
  const [x1, y1, x2, y2] = geometry.crop || [0, 0, geometry.baseWidth, geometry.baseHeight];
  return {
    transformOrigin: '0 0', transform: `matrix(${a},${b},${c},${d},${e * zoom},${f * zoom})`,
    clipPath: `inset(${Math.max(0, geometry.baseHeight - y2) * zoom}px ${Math.max(0, geometry.baseWidth - x2) * zoom}px ${Math.max(0, y1) * zoom}px ${Math.max(0, x1) * zoom}px)`,
  };
}

export function localDelta(x, y, rotation = 0) {
  if (rotation === 90) return { x: y, y: -x };
  if (rotation === 180) return { x: -x, y: -y };
  if (rotation === 270) return { x: -y, y: x };
  return { x, y };
}

export function pointOnPage(clientX, clientY, rect, zoom, geometry) {
  const [a, b, c, d, e, f] = geometry.matrix || [1, 0, 0, 1, 0, 0];
  const x = (clientX - rect.left) / zoom - e, y = (clientY - rect.top) / zoom - f;
  const determinant = a * d - b * c;
  return { x: (d * x - c * y) / determinant, y: (a * y - b * x) / determinant };
}

export function localPoint(event, rect, zoom, width, height, rotation = 0) {
  const x = (event.clientX - rect.left) / zoom;
  const y = (event.clientY - rect.top) / zoom;
  if (rotation === 90) return { x: y, y: height - x };
  if (rotation === 180) return { x: width - x, y: height - y };
  if (rotation === 270) return { x: width - y, y: x };
  return { x, y };
}
